import { render, staticRenderFns } from "./MulchQuestion.vue?vue&type=template&id=b24d4942&scoped=true&"
import script from "./MulchQuestion.vue?vue&type=script&lang=ts&"
export * from "./MulchQuestion.vue?vue&type=script&lang=ts&"
import style0 from "./MulchQuestion.vue?vue&type=style&index=0&id=b24d4942&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b24d4942",
  null
  
)

export default component.exports